import classNames from "classnames/bind";
import SmartLink from "common/wrapper/SmartLink";
import * as React from "react";

import type { ResolvedSubNavItems } from "resolvers/base/subNavigationResolver";
import { StepView } from "../interfaces";
import { MenuHeader } from "../MenuHeader";
import styles from "./SubMenu.module.scss";

const cx = classNames.bind(styles);

export type SubMenuProps = {
    handleBackStepView: () => void;
    handleNextStepView: (stepView: StepView) => void;
    stepViewData: StepView;
    subMenuItems: ResolvedSubNavItems[];
    prefetch?: boolean;
};

export const SubMenu: React.FC<SubMenuProps> = ({
    handleBackStepView,
    handleNextStepView,
    stepViewData,
    subMenuItems,
    prefetch = false,
}) => {
    const { stepData } = stepViewData;
    const menuHeaderTitle = stepData ? stepData.text : "";
    const menuData = stepData ? subMenuItems?.find((item) => item.id === stepData.subMenuId) : null;

    let subMenuItemsById;
    if (menuData) {
        const subMenu = subMenuItems.find((e) => e.id === menuData.id);
        if (subMenu) {
            subMenuItemsById = subMenu.items;
        }
    }

    // @TODO key value must be set as a string after integration with CMS
    return (
        <div style={{ height: "100%" }}>
            <div className={cx("wrapper")}>
                <MenuHeader handleBackStepView={handleBackStepView} title={menuHeaderTitle} />
                {subMenuItemsById && (
                    <ul className={cx("list")}>
                        {subMenuItemsById.map((subMenuItem, index) => (
                            <React.Fragment key={index}>
                                {subMenuItem?.text && subMenuItem?.link && (
                                    <li className={cx("listItem")}>
                                        {subMenuItem?.link ? (
                                            <SmartLink
                                                href={subMenuItem.link}
                                                prefetch={!!prefetch}
                                            >
                                                <a className={cx("listItemLink")}>
                                                    {subMenuItem?.text}
                                                </a>
                                            </SmartLink>
                                        ) : (
                                            subMenuItem?.text
                                        )}
                                    </li>
                                )}
                                {subMenuItem?.text && !subMenuItem?.link && (
                                    <li
                                        className={cx("listItem")}
                                        onClick={() =>
                                            handleNextStepView({
                                                stepIndex: 2,
                                                stepData: subMenuItem,
                                            })
                                        }
                                    >
                                        {subMenuItem?.text}
                                    </li>
                                )}
                            </React.Fragment>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
};
